import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

export default class FourOhFour extends BLComponent 
{

	constructor ( props, context )
	{
		super(props, context);

		this.state = {
			searchQuery: ''
		};

	}

	render() 
	{
		return (
			<div className="main main--white">
				<div className="main__content">
					<figure className="fourohfour__image">
						<img className="fourohfour__image-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/404.png"}/>
					</figure>
					{this.renderSearch()}
					{blapp.config.disable_xp ? this.renderExploreClassic() : this.renderExplore()}
				</div>
			</div>
		);
	}

	renderSearch() 
	{
		const	actionTarget	= blapp.url2.getSearchUrl(this.state.searchQuery)
		return (
			<section className="fourohfour__search">
				<h2 className="page-title l-margin-bottom">Sorry!</h2>
				<p className="l-margin-bottom--xl">We looked everywhere but we couldn't find what you were looking for. Try using the search field below.</p>
				<form className="search-lockup search-lockup--bordered" method="post" action={actionTarget}>
					<div className="search-lockup__input-container">
						<input type="text" className="search-lockup__input search-lockup__input--start fourohfour__search-input l-pad-left" placeholder={$T('SEARCH_PLACEHOLDER')} value={this.state.searchQuery} onChange={(e) => this.setState({searchQuery: e.target.value})}/>
						{this.state.searchQuery ? <button type="button" className="btn btn--blank search-lockup__btn--clear" onClick={() => this.setState({searchQuery: ''})}><i className="fas fa-times-circle"/></button> : null}
					</div>
					<button type="submit" className="search-lockup__btn search-lockup__btn--end fourohfour__search-btn"><i className="far fa-search"/></button>
				</form>
			</section>
		);
	}

	renderExplore() 
	{
		return (
			<section className="home-section home-section--extra-space">
				<h3 className="text--center section-title home-section__title--large">{$T("EXPLORE_TITLE")}</h3>
				<div className="card-container">
					<article className="home-type-card home-type-card--sets">
						<div className="home-type-card__internal card__internal card__internal--shadow">
							<h3 className="section-title home-type-card__title"><a className="link--inherit" href={blapp.url2.getCatalogBrowseUrl("S:")}>{$T('SETS')}</a></h3>
							<p className="home-type-card__desc">From the newest to rare vintage</p>
							<div className="home-type-card__content">
								<div className="home-type-card__image">
									<a href={blapp.url2.getCatalogBrowseUrl("S:")}>
										<img src={"//" + blapp.config.getHost( "static2" ) + "/img/home-imgs/set-image.png"}/>
									</a>
								</div>
								<div className="home-type-card__links">
									<ul className="l-margin-bottom--xl">
										<li className="home-type-card__link-item"><a href="">Star wars</a></li>
										<li className="home-type-card__link-item"><a href="">Collectible Minifigures</a></li>
										<li className="home-type-card__link-item"><a href="">Town</a></li>
										<li className="home-type-card__link-item"><a href="">Super Heroes</a></li>
										<li className="home-type-card__link-item"><a href="">Holiday</a></li>
										<li className="home-type-card__link-item"><a href="">Creator</a></li>
									</ul>
									<a href={blapp.url2.getCatalogBrowseUrl("S:")} className="home-type-card__link">{$T('SEE_ALL')}<i className="l-margin-left--sm fas fa-long-arrow-right"/></a>
								</div>
							</div>
						</div>
					</article>
					<article className="home-type-card home-type-card--parts">
						<div className="home-type-card__internal card__internal card__internal--shadow">
							<h3 className="section-title home-type-card__title"><a className="link--inherit" href={blapp.url2.getCatalogBrowseUrl("P:")}>{$T('PARTS')}</a></h3>
							<p className="home-type-card__desc">Find the right piece for your build</p>
							<div className="home-type-card__content">
								<div className="home-type-card__image home-type-card__image--part">
									<a href={blapp.url2.getCatalogBrowseUrl("P:")}>
										<img src={"//" + blapp.config.getHost( "static2" ) + "/img/home-imgs/part-image.png"}/>
									</a>
								</div>
								<div className="home-type-card__links">
									<ul className="l-margin-bottom--xl">
										<li className="home-type-card__link-item"><a href="">Brick</a></li>
										<li className="home-type-card__link-item"><a href="">Plate</a></li>
										<li className="home-type-card__link-item"><a href="">Tile</a></li>
										<li className="home-type-card__link-item"><a href="">Slope</a></li>
										<li className="home-type-card__link-item"><a href="">Bar</a></li>
										<li className="home-type-card__link-item"><a href="">Technic</a></li>
									</ul>
									<a href={blapp.url2.getCatalogBrowseUrl("P:")} className="home-type-card__link">{$T('SEE_ALL')}<i className="l-margin-left--sm fas fa-long-arrow-right"/></a>
								</div>
							</div>
						</div>
					</article>
					<article className="home-type-card home-type-card--minifigs">
						<div className="home-type-card__internal card__internal card__internal--shadow">
							<h3 className="section-title home-type-card__title"><a className="link--inherit" href={blapp.url2.getCatalogBrowseUrl("M:")}>{$T('MINIFIGS')}</a></h3>
							<p className="home-type-card__desc">Bring life to your builds</p>
							<div className="home-type-card__content">
								<div className="home-type-card__image">
									<a href={blapp.url2.getCatalogBrowseUrl("M:")}>
										<img src={"//" + blapp.config.getHost( "static2" ) + "/img/home-imgs/minifig-image.png"}/>
									</a>
								</div>
								<div className="home-type-card__links">
									<ul className="l-margin-bottom--xl">
										<li className="home-type-card__link-item"><a href="">Star Wars</a></li>
										<li className="home-type-card__link-item"><a href="">Super Heroes</a></li>
										<li className="home-type-card__link-item"><a href="">Town</a></li>
										<li className="home-type-card__link-item"><a href="">Collectible Minifigures</a></li>
										<li className="home-type-card__link-item"><a href="">Ninjago</a></li>
										<li className="home-type-card__link-item"><a href="">Castle</a></li>
									</ul>
									<a href={blapp.url2.getCatalogBrowseUrl("M:")} className="home-type-card__link">{$T('SEE_ALL')}<i className="l-margin-left--sm fas fa-long-arrow-right"/></a>
								</div>
							</div>
						</div>
					</article>
				</div>
			</section>
		);
	}

	renderExploreClassic() 
	{
		return (
			<section className="home-section home-section--extra-space">
				<h3 className="text--center section-title home-section__title--large">{$T("EXPLORE_TITLE")}</h3>
				<div className="card-container">
					<article className="home-type-card home-type-card--sets">
						<div className="home-type-card__internal card__internal card__internal--shadow">
							<h3 className="section-title home-type-card__title"><a className="link--inherit" href="https://www.bricklink.com/catalogTree.asp?itemType=S">{$T('SETS')}</a></h3>
							<p className="home-type-card__desc">From the newest to rare vintage</p>
							<div className="home-type-card__content">
								<div className="home-type-card__image">
									<a href="https://www.bricklink.com/catalogTree.asp?itemType=S">
										<img src={"//" + blapp.config.getHost( "static2" ) + "/img/home-imgs/set-image.png"}/>
									</a>
								</div>
								<div className="home-type-card__links">
									<ul className="l-margin-bottom--xl">
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=S&catString=65">Star wars</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=S&catString=746">Collectible Minifigures</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=S&catString=67">Town</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=S&catString=768">Super Heroes</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=S&catString=390">Holiday</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=S&catString=171">Creator</a></li>
									</ul>
									<a href="https://www.bricklink.com/catalogTree.asp?itemType=S" className="home-type-card__link">{$T('SEE_ALL')}<i className="l-margin-left--sm fas fa-long-arrow-right"/></a>
								</div>
							</div>
						</div>
					</article>
					<article className="home-type-card home-type-card--parts">
						<div className="home-type-card__internal card__internal card__internal--shadow">
							<h3 className="section-title home-type-card__title"><a className="link--inherit" href="https://www.bricklink.com/catalogTree.asp?itemType=P">{$T('PARTS')}</a></h3>
							<p className="home-type-card__desc">Find the right piece for your build</p>
							<div className="home-type-card__content">
								<div className="home-type-card__image home-type-card__image--part">
									<a href="https://www.bricklink.com/catalogTree.asp?itemType=P">
										<img src={"//" + blapp.config.getHost( "static2" ) + "/img/home-imgs/part-image.png"}/>
									</a>
								</div>
								<div className="home-type-card__links">
									<ul className="l-margin-bottom--xl">
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=P&catString=5">Brick</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=P&catString=26">Plate</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=P&catString=37">Tile</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=P&catString=31">Slope</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=P&catString=46">Bar</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=P&catString=36">Technic</a></li>
									</ul>
									<a href="https://www.bricklink.com/catalogTree.asp?itemType=P" className="home-type-card__link">{$T('SEE_ALL')}<i className="l-margin-left--sm fas fa-long-arrow-right"/></a>
								</div>
							</div>
						</div>
					</article>
					<article className="home-type-card home-type-card--minifigs">
						<div className="home-type-card__internal card__internal card__internal--shadow">
							<h3 className="section-title home-type-card__title"><a className="link--inherit" href="https://www.bricklink.com/catalogTree.asp?itemType=M">{$T('MINIFIGS')}</a></h3>
							<p className="home-type-card__desc">Bring life to your builds</p>
							<div className="home-type-card__content">
								<div className="home-type-card__image">
									<a href="https://www.bricklink.com/catalogTree.asp?itemType=M">
										<img src={"//" + blapp.config.getHost( "static2" ) + "/img/home-imgs/minifig-image.png"}/>
									</a>
								</div>
								<div className="home-type-card__links">
									<ul className="l-margin-bottom--xl">
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=M&catString=65">Star Wars</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=M&catString=768">Super Heroes</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=M&catString=67">Town</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=M&catString=746">Collectible Minifigures</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=M&catString=759">Ninjago</a></li>
										<li className="home-type-card__link-item"><a href="https://www.bricklink.com/catalogList.asp?catType=M&catString=9">Castle</a></li>
									</ul>
									<a href="https://www.bricklink.com/catalogTree.asp?itemType=M" className="home-type-card__link">{$T('SEE_ALL')}<i className="l-margin-left--sm fas fa-long-arrow-right"/></a>
								</div>
							</div>
						</div>
					</article>
				</div>
			</section>
		);
	}	
};

document.addEventListener("DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<FourOhFour blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-error-fourohfour' )
						);
		blapp.refs.register( "main", elem );
	}
);


var $T = BLComponent.createTextMap( 
		{
			"SEARCH_PLACEHOLDER":
			{
				"en":	"Search LEGO products"
			,	"kr":	"아이템 검색"
			,	"es":	"Busca productos LEGO"
			}
		,	"SETS":
			{
				"en":	"Sets"
			,	"kr":	"세트"
			,	"es":	"Sets"
			}
		, 	"MINIFIGS":
				{
					"en": "Minifigures"
				,	"kr": "미니피규어"
				,	"es": "Minifigures"
				}
		, 	"PARTS":
				{
					"en": "Parts"
				,	"kr": "파트"
				,	"es": "Partes"
				}
		,	"EXPLORE_TITLE":
				{
					"en": "Explore the world's largest LEGO marketplace!"
				,	"kr": "세계 최대의 레고 마켓플레이스를 마음껏 둘러보세요!"
				,	"es": "¡Explora el marketplace de LEGO más grande del mundo!"
				}
		, 	"SEE_ALL":
				{
					"en": "See all"
				,	"kr": "전체 보기"
				,	"es": "Ver todo"
				}
	}
);